/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Search_DriverInputs */

const en_orders_search_driver = /** @type {(inputs: Orders_Search_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search driver...`)
};

const es_orders_search_driver = /** @type {(inputs: Orders_Search_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar chofer...`)
};

/**
* | output |
* | --- |
* | "Search driver..." |
*
* @param {Orders_Search_DriverInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_search_driver = /** @type {((inputs?: Orders_Search_DriverInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Search_DriverInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_search_driver(inputs)
	return es_orders_search_driver(inputs)
});